import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more-version",
  "use": "icon-more-version-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol viewBox=\"0 0 44 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-more-version\">\n<rect x=\"10\" y=\"16\" width=\"24\" height=\"3\" rx=\"1\" fill=\"white\" />\n<rect x=\"10\" y=\"25\" width=\"16\" height=\"3\" rx=\"1\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol